// extracted by mini-css-extract-plugin
export default {"col":"index_col_L-4mH","mid_gy":"index_mid_gy_t9NN-","mid_gy_left":"index_mid_gy_left_fPy8t","current":"index_current_o4ojY","mid_gy_right":"index_mid_gy_right_fltdG"};